<template>
    <x-app class="x-layout-docs">
        <v-app-bar app fixed dense flat dark :clipped-left="$vuetify.breakpoint.lgAndUp" color="one" class="x-toolbar">
            <v-toolbar-title class="w-toolbar-title font-weight-light d-flex">
                <v-img src="@/assets/imgs/logo/light/4.png" max-width="30"></v-img>
            </v-toolbar-title>

            <v-toolbar-title class="font-weight-light pl-3"> XTPG - UI </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items class="d-lg-none ml-1">
                <v-btn @click.stop="sidebar = !sidebar" text min-width="48" class="px-1">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>

        <v-navigation-drawer v-model="sidebar" app fixed :clipped="$vuetify.breakpoint.lgAndUp" :color="!$vuetify.theme.isDark ? 'grey lighten-3' : ''" width="250">
            <x-tree-menu :items="menu.items"></x-tree-menu>
        </v-navigation-drawer>
    </x-app>
</template>

<script>
import menu from '../data/menu';

export default {
    name: 'LayoutDocs',
    data() {
        return {
            sidebar: true,
            menu,
        }
    },
    methods: {
        openExternalPath(app) {
            const route = this.$router.resolve({ path: app.path });
            window.open(route.href, '_blank');
        },
    },
}
</script>

<style scoped>

</style>
